import { Button } from '@octopus-do/octopus-storybook'
import type React from 'react'

import Octopus from '../../assets/images/error.svg?react'
import css from './NotFound.module.scss'

const NotFound: React.FC = () => {
  return (
    <div className={css.container}>
      <a className={css.logo} href="/">
        <Octopus />
      </a>
      <div className={css.content}>
        <div className={css.heading}>Oops… Page not found</div>
        <div className={css.body}>
          We’re unable to find the page you’re
          <br />
          looking for. Check the link, or go to
          <br />
          the app or website instead.
        </div>
        {/* The static 404.html is served without JavaScript, so each button
            submits a GET form to its page rather than navigating on click */}
        <div className={css.actions}>
          <form action="/" method="get">
            <Button
              className={css.outlineButton}
              type="submit"
              priority="outline"
              size="medium"
              label="Back to app"
            />
          </form>
          <form action="/sitemap/" method="get">
            <Button
              type="submit"
              priority="ghost"
              size="medium"
              label="Back to website"
            />
          </form>
        </div>
      </div>
    </div>
  )
}

export default NotFound
